<template>
  <div>
    <el-page-header @back="goBack" content="模块实例" v-if="device.name"></el-page-header>
    <h3 style="margin-top: 0px;" v-else>模块实例</h3>

    <div class="divCon" v-if="device.name">设备：{{ device.name }}</div>

    <div class="divCon">
      <!--      <el-input placeholder="搜索" v-model="search"-->
      <!--                @keyup.enter.native="resetEvent" >-->
      <!--        <el-button slot="append" icon="el-icon-search" @click="resetEvent"></el-button>-->
      <!--      </el-input>-->
      <el-input v-model="searchType" placeholder="请输入" @change="resetEvent">
        <el-select v-model="searchCondition" slot="prepend" placeholder="请选择" style="width: 130px">
          <el-option v-for="(option, index) in conditionList"
                     :key="index"
                     :value="option.type"
                     :label="option.value"></el-option>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click="resetEvent"></el-button>
      </el-input>
    </div>
    <module-instance-list
      ref="child"
      :device="device.id"
      :search="searchType"
      :searchCondition="searchCondition"/>
  </div>
</template>
<script>
import ModuleInstanceList from './common/ModuleInstanceList.vue'

export default {
  name: 'ModuleInstance',
  components: {ModuleInstanceList},
  data: vm => ({
    searchType: '',
    searchCondition: null,
    parent: '',
    list: [],
    device: {}, //设备信息
    conditionList: [
      {
        type: null,
        value: '全部'
      }, {
        type: 'alias',
        value: '实例别名'
      }, {
        type: 'integration_version_alias',
        value: '集成名称'
      }, {
        type: 'integration_version_version',
        value: '集成版本'
      }, {
        type: 'module_type',
        value: '模块类型'
      }, {
        type: 'id',
        value: '实例id'
      }, {
        type: 'device_id',
        value: '设备id'
      }],
  }),
  created() {
    const params = this.$route.params;
    this.device = params.device ? params.device : {}
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    resetEvent() {
      this.$refs.child.getResetPage();
    }
  }
}
</script>
<style scoped>
.divCon {
  width: 40%;
  margin: 20px 0px;
}
</style>
